export const SETTING_UPDATE_MODAL = 'settingUpdateModal';
export const SETTING_UPDATE_PATH = '/api/settings/:id';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/SettingUpdateModal/SettingUpdateModalConstants.js